import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import { Splash } from '../Splash/Splash/Splash';
import {
  getAssetDisplayTitle,
  getAssetMainImage,
} from '../../shared/helpers/assetHelpers';
import { getAssetLabels } from '../Splash/AssetSplash/getAssetLabels';

import type { SvpAssetAdditional } from '@vgtv/api-client/lib/svp_asset';

import * as styles from './ExpiredDocumentarySplash.module.scss';

type Props = {
  asset: SvpAssetAdditional;
};

function ExpiredDocumentarySplash({ asset }: Props) {
  const { description } = asset;

  const { t } = useTranslation();

  const imageUrl = getAssetMainImage(asset);

  return (
    <div className={classNames(styles.container, {})}>
      <Splash
        imageUrl={imageUrl}
        title={getAssetDisplayTitle(asset)}
        subtitle={t('No longer available')}
        description={description}
        lazy={false}
        labels={getAssetLabels(asset)}
      />
    </div>
  );
}

export { ExpiredDocumentarySplash };
